import { Link } from 'react-router-dom';
import { VStack } from '@chakra-ui/react';

import { BankAccount } from '__generated__/GQL';
import { getBankAccountDisplayNameWithSpecificLocale } from 'common/bankAccount/utils';
import { formatAmount } from 'common/formatAmount';
import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import SunshineCard from 'components/_core/SunshineCard';
import * as routes from 'features/Bank/routes';
import * as Layout from 'layouts/StepperLayout';

import flyingBillsVideo from './flying-bills.mp4';
import locales from './locales';
import { TransferSuccessText } from './styles';

type SuccessProps = {
  amount: number;
  fromBankAccount: Pick<BankAccount, 'type' | 'name' | 'bankAccountId'>;
  recipient: string;
  transferLocales: {
    title: string;
    description: string;
    transferDetails?: string;
  };
  donePath?: string;
};

const Success = ({
  amount,
  donePath = routes.root,
  fromBankAccount,
  recipient,
  transferLocales,
}: SuccessProps) => {
  const fromBankAccountName = getBankAccountDisplayNameWithSpecificLocale({
    bankAccount: fromBankAccount,
    locale: locales.yourMainAccount,
  });
  const formattedAmount = formatAmount({
    forcePlusSign: false,
    value: amount ?? 0,
  });

  return (
    <Layout.Root>
      <Layout.Body>
        <SunshineCard.Group width="600px">
          <SunshineCard alignItems="center" textAlign="center">
            <VStack alignItems="center" padding="space-24" spacing="space-24">
              <video autoPlay loop muted width="180px">
                <source src={flyingBillsVideo} type="video/mp4" />
              </video>
              <Heading size="lg">{transferLocales.title}</Heading>
              <VStack alignItems="center" gap={0}>
                <TransferSuccessText>
                  {locales.formatString(transferLocales.description, {
                    amount: formattedAmount,
                    from: fromBankAccountName,
                    to: recipient,
                  })}
                </TransferSuccessText>
                {transferLocales.transferDetails ? (
                  <TransferSuccessText>
                    {transferLocales.transferDetails}
                  </TransferSuccessText>
                ) : null}
              </VStack>
            </VStack>
          </SunshineCard>
          <SunshineCard textAlign="center">
            <Button as={Link} isExpanded margin="space-8" to={donePath}>
              {locales.done}
            </Button>
          </SunshineCard>
        </SunshineCard.Group>
      </Layout.Body>
    </Layout.Root>
  );
};

export default Success;
